import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Token } from '../models/token.model';
import { Response } from '../models/response.model';

@Injectable({
  providedIn: 'root'
})
export class GirisService {

  constructor(private http: HttpClient) { }

  apiUrl = '/api/auth';
  giris(tckimlikno: number, sifre: string, uid : string): Observable<Response<Token>> {
    return this.http.post<Response<Token>>(this.apiUrl + '/login', {
      tckimlikno,
      sifre,
      uid
    });
  }

  refreshToken(userUid: string): Observable<Response<Token>> {
    return this.http.post<Response<Token>>(this.apiUrl + '/refreshtoken?useruid=' + userUid, {});
  }

}
